import {
	Box,
	Button,
	CircularProgress,
	InputLabel,
	MenuItem,
	Select,
	Stack,
	TextField,
	Typography,
} from "@mui/material";
import { fileData, fileTypesData } from "data/supplierPageData";
import { useState } from "react";
import { modalLabelSx, supplierUi } from "../../../shared/supplierUi";

const AddFiles = ({ fullWidth, files, setFiles, submitFunction, disableAdd }) => {
	const [updatedDetails, setUpdatedDetails] = useState(fileData);
	const [file, setFile] = useState(null);
	const [loading, setLoading] = useState(false);

	const handleFormSubmit = async (e) => {
		e.preventDefault();
		if (disableAdd || loading) return;
		setLoading(true);
		try {
			if (typeof submitFunction === "function") {
				const created = await submitFunction({ ...updatedDetails, file }, false);
				if (created) {
					setUpdatedDetails(fileData);
					setFile(null);
					e.target.reset?.();
				}
			}
		} finally {
			setLoading(false);
		}
	};

	return (
		<Box
			component="form"
			onSubmit={handleFormSubmit}
			sx={{
				width: fullWidth ? "100%" : { xs: "100%", md: 300 },
				border: `1px solid ${supplierUi.border}`,
				borderRadius: supplierUi.radius,
				bgcolor: "#FAFAFA",
				p: 2,
				boxSizing: "border-box",
			}}>
			<Typography
				sx={{
					fontWeight: 600,
					fontSize: 15,
					color: supplierUi.textPrimary,
					mb: 1.75,
				}}>
				Add file
			</Typography>
			<Stack spacing={1.75}>
				<Stack spacing={0.5}>
					<InputLabel sx={modalLabelSx}>File name</InputLabel>
					<TextField
						size="small"
						type="text"
						value={updatedDetails?.name || ""}
						onChange={(e) => setUpdatedDetails({ ...updatedDetails, name: e.target.value })}
						placeholder="Enter file name"
						required
						disabled={disableAdd}
						sx={{
							bgcolor: "#fff",
							"& .MuiOutlinedInput-root": { borderRadius: 1.5 },
						}}
					/>
				</Stack>
				<Stack spacing={0.5}>
					<InputLabel sx={modalLabelSx}>File type</InputLabel>
					<Select
						value={updatedDetails?.type || "select"}
						onChange={(e) => setUpdatedDetails({ ...updatedDetails, type: e.target.value })}
						MenuProps={{ PaperProps: { sx: { maxHeight: 200 } } }}
						size="small"
						required
						disabled={disableAdd}
						sx={{ bgcolor: "#fff", borderRadius: 1.5 }}>
						<MenuItem value="select">Select</MenuItem>
						{fileTypesData?.map((row) => (
							<MenuItem key={row.Key} value={row.Key}>
								{row.name}
							</MenuItem>
						))}
					</Select>
				</Stack>
				<Stack spacing={0.5}>
					<InputLabel sx={modalLabelSx}>Upload file</InputLabel>
					<TextField
						size="small"
						type="file"
						onChange={(e) => setFile(e.target.files?.[0] || null)}
						required
						disabled={disableAdd}
						inputProps={{ key: file ? file.name : "empty" }}
						sx={{
							bgcolor: "#fff",
							"& .MuiOutlinedInput-root": { borderRadius: 1.5 },
						}}
					/>
				</Stack>
				<Button
					disabled={disableAdd || loading}
					startIcon={loading ? <CircularProgress color="inherit" size={16} /> : null}
					variant="contained"
					type="submit"
					fullWidth
					sx={{
						mt: 0.5,
						textTransform: "none",
						fontWeight: 600,
						borderRadius: 1.5,
						boxShadow: "none",
						"&:hover": { boxShadow: "none" },
					}}>
					{loading ? "Uploading…" : "Add file"}
				</Button>
			</Stack>
		</Box>
	);
};

export default AddFiles;
